/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import DOMPurify from 'dompurify';
import ReactHTMLParser from 'react-html-parser';

/**
 * Sanitizes HTML content to prevent XSS attacks
 * @param {string} content - The content to be sanitized
 * @param {Object} [options] - Optional DOMPurify configuration options
 * @returns {string} - The sanitized content
 */
export const sanitizeContent = (content, options = {}) => {
    if (typeof content !== 'string') {
        return '';
    }

    return ReactHTMLParser(DOMPurify.sanitize(content, {
        ...options,
        RETURN_DOM: false,
        RETURN_DOM_FRAGMENT: false,
        RETURN_TRUSTED_TYPE: false,
    }));
};

export default sanitizeContent;
